module.exports = __webpack_public_path__ + "static/media/Me3_2ndEdition-128s.a3b3a5bb.gif";